import { DlVault } from 'types/contracts';

export interface GetReferrerInfoInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetReferrerInfoOutput = {
  referrer: string;
  hasReferrer: boolean;
  directReferrals: number;
};

const getReferrerInfo = async ({
  dlVaultContract,
  accountAddress,
}: GetReferrerInfoInput): Promise<GetReferrerInfoOutput> => {
  const result = await dlVaultContract.methods
    .getReferrerInfo(accountAddress)
    .call();

  return {
    referrer: result.referrer || '0x0000000000000000000000000000000000000000',
    hasReferrer: result.hasReferrer || false,
    directReferrals: parseInt(result.directReferrals || '0', 10),
  };
};

export default getReferrerInfo; 